import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { DISCOUNTS } from "./content";

const SPANS = ["lg:col-span-4", "lg:col-span-2", "lg:col-span-2", "lg:col-span-4"];

const Card = ({ d, wide, i }) => (
  <motion.article
    initial={{ opacity: 0.2, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: (i % 2) * 0.1 }}
    whileHover={{ y: -6 }}
    className={`group relative flex min-h-[420px] flex-col overflow-hidden rounded-[2rem] border border-white/10 bg-graphite ${SPANS[i]}`}
    data-testid={`discount-card-${d.id}`}
  >
    <div className={`relative overflow-hidden ${wide ? "h-56 lg:absolute lg:inset-y-0 lg:right-0 lg:h-auto lg:w-[46%]" : "h-48"}`}>
      <img src={d.img} alt={d.title} className={`h-full w-full object-cover ${d.pos || ""} grayscale-[35%] transition-transform duration-[1.2s] ease-out group-hover:scale-105 group-hover:grayscale-0`} />
      <div className={`absolute inset-0 ${wide ? "bg-gradient-to-t from-graphite lg:bg-gradient-to-r" : "bg-gradient-to-t from-graphite via-transparent"} to-transparent`} />
    </div>
    <div className={`relative flex flex-1 flex-col p-7 sm:p-9 ${wide ? "lg:w-[58%]" : ""}`}>
      <div className="flex items-center justify-between">
        <span className="font-mono text-xs uppercase tracking-[0.22em] text-lane">{d.tag}</span>
        <span className="font-display text-5xl font-black text-outline-dim">{d.no}</span>
      </div>
      <h3 className="mt-4 font-display text-4xl font-black uppercase leading-[0.95] text-bone">{d.title}</h3>
      <p className="mt-4 font-body text-sm leading-relaxed text-mist sm:text-base">{d.body}</p>
      <p className="mt-auto flex gap-3 border-t border-white/10 pt-5 font-body text-sm text-bone">
        <Check className="mt-0.5 h-4 w-4 shrink-0 text-lane" /> {d.claim}
      </p>
    </div>
  </motion.article>
);

export const Discounts = () => (
  <section id="discounts" className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 lg:py-32" data-testid="discounts-section">
    <Reveal className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
      <div>
        <Eyebrow>The four discounts</Eyebrow>
        <h2 className="mt-6 max-w-3xl font-display text-5xl font-black uppercase leading-[0.92] text-bone sm:text-6xl lg:text-7xl">
          Four ways to <span className="text-lane">save</span> on a new driver.
        </h2>
      </div>
      <p className="max-w-sm font-body text-sm leading-relaxed text-mist sm:text-base">
        Plain-English explanations for parents. Availability and amounts vary by insurance company and eligibility; we check each one for your family.
      </p>
    </Reveal>
    <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-6">
      {DISCOUNTS.map((d, i) => (
        <Card key={d.id} d={d} i={i} wide={i === 0 || i === 3} />
      ))}
    </div>
  </section>
);
